import { Routes } from '@angular/router';

import { Dashboard } from './pages/dashboard/dashboard';
import { Simulation } from './pages/simulation/simulation';
import { Workflow } from './pages/workflow/workflow';
import { DataCatalogue } from './pages/data-catalogue/data-catalogue';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  { path: 'dashboard', component: Dashboard },
  { path: 'simulation', component: Simulation },
  { path: 'workflow', component: Workflow },
  { path: 'data-catalogue', component: DataCatalogue },

  { path: '**', redirectTo: 'dashboard' }
];